import { ProviderUser } from "@/common/types/ProviderUser";
import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";

function useProviderUser(): ProviderUser {
  const trpc = useTRPC();
  const result = useQuery(trpc.provider.getProviderUser.queryOptions());
  if (result.error) {
    throw result.error;
  }
  if (!result.data) {
    throw new Error("Provider user data is unavailable");
  }
  return result.data;
}

export { useProviderUser };
